export const avatarFrameGradient = (color: string): string =>
  `conic-gradient(from 0deg, color-mix(in srgb, ${color} 58%, white), ${color}, color-mix(in srgb, ${color} 72%, #22d3ee), color-mix(in srgb, ${color} 62%, white), ${color})`;
